import styled from 'styled-components';

export const SectionHeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3px;
`;
